import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AccessFrom, SharepointAccessList } from '@/core/interfaces/sharepoint-access.interface';
import { NotificationItem } from '@/core/store/notifications.store';
import { SharepointStore } from '@/store/sharepoint.store';
import { HseReservoir } from 'src/app/portal/hsa/reservorio-spo-hse';
import { UserGuidesReservoir } from 'src/app/portal/library/user-guides/user-guides.reservoir';
import { MarketingReservoir } from 'src/app/portal/marketing/reservorio-spo-mkt';
import { LoyaltyReservoir } from 'src/app/portal/on-program/reservorio-loyalty';
import { PaymentsReservoir } from 'src/app/portal/payments/learn-payment-methods/reservorio-spo-payments';
import { QualityReservoir } from 'src/app/portal/quality/reservorio-quality';
import { StoreReservoir } from 'src/app/portal/store/reservorio-spo-store';
import { EngMaintenanceReservoir } from 'src/app/portal/engineering-maintenance/reservorio-eng-maintenance';
import { AxionCardReservoir } from 'src/app/portal/axion-card/reservorio-axion-card';
import { CustomerExperienceReservoir } from 'src/app/portal/customer-experience/reservorio-customer-experience';
import { BibliotecaReservoir } from 'src/app/portal/library/reservorio-spo-biblioteca';
import { LubesPriceListReservoir } from 'src/app/portal/lubes/reservorio-lubes-price-list';
import { OperationsManagementReservoir } from 'src/app/portal/operations-management/reservorio-operations-management';

export interface UserType {
  isRetailFuels: boolean;
  isRetailLubes: boolean;
  isRetailSpot: boolean;
  isRetailFuelsWithRCOR: boolean;
}

@Injectable({ providedIn: 'root' })
export class NotificationHelper {
  private router = inject(Router);
  private sharepointStore = inject(SharepointStore);

  //! ARREGLOS DE LISTAS DE SHAREPOINT SEGÚN LA SECCIÓN
  private readonly HSE = [
    'HSE_BTC_Estaciones_de_Servicio',
    'HSE_BTB_Industria_Agro',
    'HSE_LBU_Lubricantes_Castrol',
    'HSE_Campanas_de_Comunicacion',
    'HSE_Capacitaciones',
    'HSE_Cultura_de_Seguridad',
    'HSE_Tienda_Spot',
  ];
  private readonly MARKETING = [
    'MARKETING_Piezas_Comunicacion_Digital',
    'MARKETING_Manuales_de_Marca',
    'MARKETING_Piezas_de_Campana',
  ];
  private readonly STORE = ['TIENDAS_Lanzamientos_Novedades', 'TIENDAS_Manuales', 'TIENDAS_Accesos_de_Interes'];
  private readonly QUALITY = [
    'CALIDAD_Combustibles',
    'CALIDAD_TopTier',
    'CALIDAD_Material_Consulta',
    'CALIDAD_AxionLabs',
  ];
  private readonly LOYALTY = ['FIDELIDAD_MATERIALES'];
  private readonly AXIONCARD = ['AXIONCARD_PSS'];
  private readonly LUBES_PRICE_LIST = ['_L_UBES_Lista_Precios'];
  private readonly PAYMENTS = ['PAGOS_MEDIOS_DE_PAGOS'];
  private readonly CUSTOMER_EXP = ['EXP_CLIENTE_MANUAL'];
  private readonly OPERATIONS_MANAGEMENT = [
    'GESTIONOPERATIVA_Manuales',
    'GESTIONOPERATIVA_Estadisticas_ConcursoPrograma',
    'MARKETING_Beneficios_Alianzas',
  ];
  private readonly GUIDES = ['GUIAS_Guias_Rapidas_de_Uso'];
  private readonly SUPPLIERS_LIST = ['BIBLIOTECA_PROVEEDORES'];
  private readonly ENGINEERING_MAINTENANCE = [
    'INGENIERIA_MANTENIMIENTO_DOCUMENTACION_LEGAL',
    'INGENIERIA_MANTENIMIENTO_CAPACITACIONES',
    'INGENIERIA_MANTENIMIENTO_PREVENTIVO',
    'INGENIERIA_MANTENIMIENTO_PROCEDIMIENTOS',
    'INGENIERIA_MANTENIMIENTO_COMUNICACIONES',
  ];

  //! RUTAS DE ACCESO A CADA LISTA DE SHAREPONT
  private readonly sectionsPaths = {
    STORES: {
      TIENDAS_Lanzamientos_Novedades: '/portal/store/releases-and-promotions',
      TIENDAS_Manuales: '/portal/store/manuals',
      TIENDAS_Accesos_de_Interes: '/portal/store',
    },
    HSE: {
      HSE_BTC_Estaciones_de_Servicio: '/portal/documents',
      HSE_BTB_Industria_Agro: '/portal/documents',
      HSE_Tienda_Spot: '/portal/documents',
      HSE_LBU_Lubricantes_Castrol: '/portal/documents',
      HSE_Cultura_de_Seguridad: '/portal/hsa/capacitations',
      HSE_Capacitaciones: '/portal/hsa/capacitations',
      HSE_Campanas_de_Comunicacion: '/portal/hsa/capacitations',
    },
    MARKETING: {
      MARKETING_Piezas_Comunicacion_Digital: '/portal/marketing/social-network',
      MARKETING_Manuales_de_Marca: '/portal/marketing/brand-guidelines',
      MARKETING_Piezas_de_Campana: '/portal/marketing/campaign-assets',
    },
    QUALITY: {
      CALIDAD_Combustibles: '/portal/quality/quality-fuels',
      CALIDAD_Material_Consulta: '/portal/quality/reference-material',
      CALIDAD_AxionLabs: '/portal/quality/axion-lab',
      CALIDAD_MedidorAguaTanques: '/portal/quality/water-measurement-in-tank',
    },
    LOYALTY: {
      FIDELIDAD_MATERIALES: '/portal/marketing/pos-materials',
    },
    AXIONCARD: {
      AXIONCARD_PSS: '/portal/axion-card',
    },
    LUBES_PRICE_LIST: {
      _L_UBES_Lista_Precios: '/portal/orders',
    },
    PAYMENTS: {
      PAGOS_MEDIOS_DE_PAGOS: '/portal/payments/learn-payment-methods',
    },
    CUSTOMER_EXP: {
      EXP_CLIENTE_MANUAL: '/portal/customer-experience',
    },
    OPERATIONS_MANAGEMENT: {
      GESTIONOPERATIVA_Manuales: '/portal/operations-management/manuals',
      GESTIONOPERATIVA_Estadisticas_ConcursoPrograma: '/portal/operations-management/incentive-contests',
      GESTIONOPERATIVA_Beneficios_Alianzas: '/portal/operations-management/benefits',
      MARKETING_Beneficios_Alianzas: '/portal/operations-management/benefits',
    },
    GUIDES: {
      GUIAS_Guias_Rapidas_de_Uso: '/portal/library/user-guides',
    },
    SUPPLIERS_LIST: {
      BIBLIOTECA_PROVEEDORES: '/portal/library',
    },

    // TODO CUANDO ESTÉ LA SECCIÓN INGENIERÍA Y MANTENIMIENTO PONER LAS URL CORRECTAS
    // ENGINEERING_MAINTENANCE: {
    //     INGENIERIA_MANTENIMIENTO_DOCUMENTACION_LEGAL:
    //         '/portal/eng-maintenance/doc-legales',
    //     INGENIERIA_MANTENIMIENTO_CAPACITACIONES:
    //         '/portal/eng-maintenance/cap-good-practices',
    //     INGENIERIA_MANTENIMIENTO_PREVENTIVO:
    //         '/portal/eng-maintenance/preventive-mant',
    //     INGENIERIA_MANTENIMIENTO_PROCEDIMIENTOS:
    //         '/portal/eng-maintenance/procedures',
    //     INGENIERIA_MANTENIMIENTO_COMUNICACIONES:
    //         '/portal/eng-maintenance/communications-news',
    // },
    DEFAULT: '/portal/home',
  };

  /**
   * Lista de repositorios accesibles desde el contexto de notificaciones ("Nuevos Contenidos")
   */
  readonly reservoriesForNotificaciones: SharepointAccessList[] = [
    { repository: HseReservoir.SERVICE_STATIONS_LIBRARY_ITEMS, library: HseReservoir.HSE_LIBRARY },
    { repository: HseReservoir.STORE_LIBRARY_ITEMS, library: HseReservoir.HSE_LIBRARY },
    { repository: HseReservoir.INDUSTRY_LIBRARY_ITEMS, library: HseReservoir.HSE_LIBRARY },
    { repository: HseReservoir.LUBRICANTS_LIBRARY_ITEMS, library: HseReservoir.HSE_LIBRARY },
    { repository: HseReservoir.CAPACITATIONS_CAMP_ITEMS, library: HseReservoir.HSE_LIBRARY },
    { repository: HseReservoir.CAPACITATIONS_CAPACITATIONS_ITEMS, library: HseReservoir.HSE_LIBRARY },
    { repository: HseReservoir.CAPACITATIONS_CULTURE_ITEMS, library: HseReservoir.HSE_LIBRARY },
    { repository: MarketingReservoir.MANUALES_ITEMS, library: MarketingReservoir.BIBLIOTECA_GENERAL },
    { repository: QualityReservoir.MATERIAL_ITEMS, library: QualityReservoir.BIBLIOTECA_GENERAL },
    { repository: QualityReservoir.COMBUSTIBLE, library: QualityReservoir.BIBLIOTECA_GENERAL },
    { repository: QualityReservoir.AXION_LAB, library: QualityReservoir.BIBLIOTECA_GENERAL },
    { repository: PaymentsReservoir.PAYMENT_METHODS_ITEMS, library: PaymentsReservoir.PAYMENT_METHODS_ITEMS },
    { repository: UserGuidesReservoir.ITEMS, library: UserGuidesReservoir.ITEMS },
    { repository: MarketingReservoir.BENEFICIOS_ITEMS, library: MarketingReservoir.BIBLIOTECA_GENERAL },
    { repository: LoyaltyReservoir.MATERIALES_ITEMS, library: LoyaltyReservoir.BIBLIOTECA_GENERAL },
    { repository: MarketingReservoir.PROMOCIONES_ITEMS, library: MarketingReservoir.BIBLIOTECA_GENERAL },
    { repository: MarketingReservoir.COMUNICACION_ITEMS, library: MarketingReservoir.BIBLIOTECA_GENERAL },
    { repository: StoreReservoir.NOVEDADES, library: StoreReservoir.STORE_LIBRARY },
    { repository: StoreReservoir.ACCESOS_ITEMS, library: StoreReservoir.STORE_LIBRARY },
    { repository: StoreReservoir.MANUAL_ITEMS, library: StoreReservoir.STORE_LIBRARY },
    { repository: AxionCardReservoir.AXIONCARD_PSS, library: AxionCardReservoir.AXIONCARD_PSS },
    { repository: LubesPriceListReservoir.PRECIOS, library: LubesPriceListReservoir.PRECIOS },
    { repository: CustomerExperienceReservoir.MANUAL, library: CustomerExperienceReservoir.MANUAL },
    {
      repository: OperationsManagementReservoir.ESTADISTICAS_CONCURSO_PROGRAMA,
      library: OperationsManagementReservoir.ESTADISTICAS_CONCURSO_PROGRAMA,
    },
    {
      repository: OperationsManagementReservoir.ACCESOS_INTERES_GENERAL,
      library: OperationsManagementReservoir.ACCESOS_INTERES_GENERAL,
    },
    { repository: OperationsManagementReservoir.MANUALES, library: OperationsManagementReservoir.MANUALES },
    { repository: BibliotecaReservoir.BIBLIOTECA_PROVEEDORES, library: BibliotecaReservoir.BIBLIOTECA_PROVEEDORES },
    { repository: EngMaintenanceReservoir.DOC_LEGALES_ITEM, library: EngMaintenanceReservoir.BIBLIOTECA_GENERAL },
    {
      repository: EngMaintenanceReservoir.CAP_GOOD_PRACTICES_ITEM,
      library: EngMaintenanceReservoir.BIBLIOTECA_GENERAL,
    },
    { repository: EngMaintenanceReservoir.PREVENTIVE_MANT_ITEM, library: EngMaintenanceReservoir.BIBLIOTECA_GENERAL },
    { repository: EngMaintenanceReservoir.PROCEDURES_ITEM, library: EngMaintenanceReservoir.BIBLIOTECA_GENERAL },
    {
      repository: EngMaintenanceReservoir.COMMUNICATIONS_NEWS_ITEM,
      library: EngMaintenanceReservoir.BIBLIOTECA_GENERAL,
    },
  ];

  getNotificationSection(listName: string): string {
    if (this.HSE.includes(listName)) return 'HSE';
    if (this.MARKETING.includes(listName)) return 'MARKETING';
    if (this.STORE.includes(listName)) return 'STORES';
    if (this.QUALITY.includes(listName)) return 'QUALITY';
    if (this.LOYALTY.includes(listName)) return 'LOYALTY';
    if (this.AXIONCARD.includes(listName)) return 'AXIONCARD';
    if (this.LUBES_PRICE_LIST.includes(listName)) return 'LUBES_PRICE_LIST';
    if (this.PAYMENTS.includes(listName)) return 'PAYMENTS';
    if (this.CUSTOMER_EXP.includes(listName)) return 'CUSTOMER_EXP';
    if (this.OPERATIONS_MANAGEMENT.includes(listName)) return 'OPERATIONS_MANAGEMENT';
    if (this.GUIDES.includes(listName)) return 'GUIDES';
    if (this.SUPPLIERS_LIST.includes(listName)) return 'SUPPLIERS_LIST';
    if (this.ENGINEERING_MAINTENANCE.includes(listName)) return 'ENGINEERING_MAINTENANCE';
    return 'DEFAULT';
  }

  getUrl(section: string, listName: string): string {
    const sectionPaths = this.sectionsPaths[section as keyof typeof this.sectionsPaths];
    if (typeof sectionPaths === 'string') {
      return this.sectionsPaths.DEFAULT;
    }
    return (sectionPaths as Record<string, string>)?.[listName] ?? this.sectionsPaths.DEFAULT;
  }

  /**
   * Obtiene el path completo basado en el nombre de la lista
   * @param listName - Nombre de la lista de SharePoint (ej: 'MARKETING_Piezas_de_Campana')
   * @returns Path completo (ej: '/portal/marketing/campaign-assets')
   */
  getNotificationPath(listName: string): string {
    const section = this.getNotificationSection(listName);
    return this.getUrl(section, listName);
  }

  /**
   * Obtiene los repositorios de SharePoint accesibles según canales y tipo de usuario.
   *
   * @param canales - Lista de canales del sitio seleccionado
   * @param userType - Tipo de usuario
   * @param accessedFrom - Contexto desde el cual se accede ('notificaciones' por defecto)
   * @returns Lista de repositorios accesibles
   */
  getAccessibleSharepointRepositories(
    canales: string[],
    userType: UserType,
    accessedFrom: AccessFrom = 'notificaciones',
  ): SharepointAccessList[] {
    // Repositorios disponibles para todos los usuarios
    const reservoriesForAll: SharepointAccessList[] = [
      { repository: HseReservoir.SERVICE_STATIONS_LIBRARY_ITEMS, library: HseReservoir.HSE_LIBRARY },
      { repository: HseReservoir.STORE_LIBRARY_ITEMS, library: HseReservoir.HSE_LIBRARY },
      { repository: HseReservoir.INDUSTRY_LIBRARY_ITEMS, library: HseReservoir.HSE_LIBRARY },
      { repository: HseReservoir.LUBRICANTS_LIBRARY_ITEMS, library: HseReservoir.HSE_LIBRARY },
      { repository: HseReservoir.CAPACITATIONS_CAMP_ITEMS, library: HseReservoir.HSE_LIBRARY },
      { repository: HseReservoir.CAPACITATIONS_CAPACITATIONS_ITEMS, library: HseReservoir.HSE_LIBRARY },
      { repository: HseReservoir.CAPACITATIONS_CULTURE_ITEMS, library: HseReservoir.HSE_LIBRARY },
      { repository: MarketingReservoir.MANUALES_ITEMS, library: MarketingReservoir.BIBLIOTECA_GENERAL },
      { repository: QualityReservoir.MATERIAL_ITEMS, library: QualityReservoir.BIBLIOTECA_GENERAL },
      { repository: PaymentsReservoir.PAYMENT_METHODS_ITEMS, library: PaymentsReservoir.PAYMENT_METHODS_ITEMS },
      { repository: UserGuidesReservoir.ITEMS, library: UserGuidesReservoir.ITEMS },
      { repository: MarketingReservoir.BENEFICIOS_ITEMS, library: MarketingReservoir.BIBLIOTECA_GENERAL },
      { repository: LoyaltyReservoir.MATERIALES_ITEMS, library: LoyaltyReservoir.BIBLIOTECA_GENERAL },
      { repository: MarketingReservoir.PROMOCIONES_ITEMS, library: MarketingReservoir.BIBLIOTECA_GENERAL },
      { repository: MarketingReservoir.COMUNICACION_ITEMS, library: MarketingReservoir.BIBLIOTECA_GENERAL },
      { repository: StoreReservoir.NOVEDADES, library: StoreReservoir.STORE_LIBRARY },
      { repository: StoreReservoir.ACCESOS_ITEMS, library: StoreReservoir.STORE_LIBRARY },
      { repository: QualityReservoir.COMBUSTIBLE, library: QualityReservoir.BIBLIOTECA_GENERAL },
    ];

    // Repositorios restringidos por canal
    const restrictedRepositories: SharepointAccessList[] = [];

    canales.forEach(canal => {
      switch (canal) {
        case '01':
          restrictedRepositories.push(
            { repository: OperationsManagementReservoir.MANUALES, library: OperationsManagementReservoir.BIBLIOTECA },
            { repository: StoreReservoir.MANUAL_ITEMS, library: StoreReservoir.STORE_LIBRARY },
            { repository: LoyaltyReservoir.MATERIALES_ITEMS, library: LoyaltyReservoir.BIBLIOTECA_GENERAL },
            { repository: OperationsManagementReservoir.MANUALES, library: OperationsManagementReservoir.MANUALES },
            {
              repository: OperationsManagementReservoir.ESTADISTICAS_CONCURSO_PROGRAMA,
              library: OperationsManagementReservoir.ESTADISTICAS_CONCURSO_PROGRAMA,
            },
          );
          break;
        case '15':
          restrictedRepositories.push({
            repository: AxionCardReservoir.AXIONCARD_PSS,
            library: AxionCardReservoir.AXIONCARD_PSS,
          });
          break;
      }
    });

    // Repositorios restringidos por tipo de shipto
    if (userType.isRetailFuels) {
      restrictedRepositories.push({
        repository: CustomerExperienceReservoir.MANUAL,
        library: CustomerExperienceReservoir.BIBLIOTECA_GENERAL,
      });
    }

    if (userType.isRetailLubes) {
      restrictedRepositories.push({
        repository: LubesPriceListReservoir.PRECIOS,
        library: LubesPriceListReservoir.PRECIOS,
      });
    }

    if (userType.isRetailSpot) {
      restrictedRepositories.push({
        repository: BibliotecaReservoir.BIBLIOTECA_PROVEEDORES,
        library: BibliotecaReservoir.BIBLIOTECA_PROVEEDORES,
      });
    }

    if (userType.isRetailFuelsWithRCOR) {
      restrictedRepositories.push(
        {
          repository: EngMaintenanceReservoir.COMMUNICATIONS_NEWS_ITEM,
          library: EngMaintenanceReservoir.BIBLIOTECA_GENERAL,
        },
        { repository: EngMaintenanceReservoir.DOC_LEGALES_ITEM, library: EngMaintenanceReservoir.BIBLIOTECA_GENERAL },
        {
          repository: EngMaintenanceReservoir.CAP_GOOD_PRACTICES_ITEM,
          library: EngMaintenanceReservoir.BIBLIOTECA_GENERAL,
        },
        {
          repository: EngMaintenanceReservoir.PREVENTIVE_MANT_ITEM,
          library: EngMaintenanceReservoir.BIBLIOTECA_GENERAL,
        },
        { repository: EngMaintenanceReservoir.PROCEDURES_ITEM, library: EngMaintenanceReservoir.BIBLIOTECA_GENERAL },
      );
    }

    // Combinar repositorios para todos con los restringidos
    const allowedRepositories: SharepointAccessList[] = [...reservoriesForAll, ...restrictedRepositories];

    // Filtrar según el contexto de acceso
    if (accessedFrom === 'notificaciones') {
      return allowedRepositories.filter(repo =>
        this.reservoriesForNotificaciones.some(notifRepo => notifRepo.repository === repo.repository),
      );
    }

    return allowedRepositories;
  }

  /**
   * Navega a la sección correspondiente de una notificación con query params
   * para filtrar y resaltar el contenido específico
   *
   * @param item - Item de notificación con la información de navegación
   */
  goToPageSection(item: NotificationItem): void {
    const currentPath = this.router.url.split('?')[0]; // Obtiene el path sin query params si los hubiera
    const targetPath = item.sectionPath;

    // Si ya estamos en la misma ruta (ej, si ya estoy en Marketing pero selecciono
    // otro item desde "Nuevos contenidos" que también está en marketing)
    if (currentPath === targetPath) {
      // CapacitationsComponent maneja múltiples tabs vía ActivatedRoute.queryParamMap:
      // se navega con query params para que el componente seleccione el tab correcto
      // y resalte el contenido sin necesidad de acceder al store directamente.
      if (targetPath === '/portal/hsa/capacitations') {
        this.router.navigate([item.sectionPath], {
          queryParams: {
            list_name: item.listName,
            list_category: item.category,
            list_sub_category: item.subcategory,
            file_name: item.title,
          },
        });
      } else {
        // Para el resto de secciones (SharepointComponent estándar): actualizar el store directamente
        // Si ya hay un item resaltado lo limpio
        this.sharepointStore.clearHighlighting();

        // Seteo los query params en el store
        this.sharepointStore.setQueryParams(item.category, item.subcategory, item.title);

        // Proceso los query params
        this.sharepointStore.processQueryParams(item.category, item.subcategory, item.title);
      }
    } else {
      // Navego a una ruta diferente
      this.router.navigate([item.sectionPath], {
        queryParams: {
          list_name: item.listName,
          list_category: item.category,
          list_sub_category: item.subcategory,
          file_name: item.title,
        },
      });
    }
  }
}
